import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";
import type { LoginErrorResponse } from "./group-actions-ordering.types";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseLoginOptions = {
  config?: MutationConfig<typeof groupActionsOrderingRepository.login, AxiosError<LoginErrorResponse>>;
};

export const useLogin = ({ config }: UseLoginOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.login(data, slug),
  });
};
